import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faHandshake,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import "./Commitment_Section.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const commitmentData = [
  {
    icon: faBullseye,
    title: "Goal Oriented",
    description:
      "Your success is our priority. We work diligently to match you with opportunities that align with your career goals and aspirations.",
  },
  {
    icon: faHandshake,
    title: "Ethical Partnership",
    description:
      "We believe in honest and ethical practices. Your trust is earned through transparency and consistent delivery of promises.",
  },
  {
    icon: faGlobe,
    title: "Global Network",
    description:
      "Our extensive network of verified employers and partners worldwide ensures you have access to the best opportunities globally.",
  },
];

function CommitmentSection() {
  return (
    <section className="commitment_section">
      <Container>
        <Row className="commitment_heading">
          <CommonHeading badge="commitment" title="Our Commitment to You" />
        </Row>

        <Row className="g-5 justify-content-center">
          {commitmentData.map((item, index) => (
            <Col key={index} xs={12} sm={6} md={4}>
              <div className="commitment_card">
                <div className="commitment_icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <h3 className="commitment_card_title">{item.title}</h3>

                <p className="commitment_card_description">
                  {item.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default CommitmentSection;
